import React from 'react';
import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../common/Loading';
import _ from 'lodash';

import getPersonas from '../../../graphql/querys/personas/getPersonas.graphql';
import deletePersona from '../../../graphql/mutations/persona/deletePersona.graphql';

import TablaPersonas from './TablaPersonas';
import { errorService } from '../../../graphql/utils/utils';

const confirm = Modal.confirm;

@compose(
  graphql(getPersonas),
  graphql(deletePersona, {
    name: 'deletePersona',
    options: {
      refetchQueries: [{ query: getPersonas }],
    },
  })
)
class VerPersonas extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
      currentPage: 1,
      listaTotal: [],
      lista: [],
      primeraCarga: true,
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id) {
    //TODO: Hacer el onDelete.
    console.log('Se desea eliminar la persona con id ', id);

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar esta persona?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deletePersona({
            variables: { _id: id },
          })
          .then(res => {
            let id = res.data.deletePersona;

            if (id) {
              yo.eliminarElementoYActualizarLista(id);

              notification.warning({
                message: 'Persona eliminada',
                description: 'Se ha eliminado la persona exitosamente',
              });
            }
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar la persona');
            console.log(err);

            errorService(err, {
              _id: id,
            });
            Modal.error({
              title:
                'Error en la eliminacion de la persona de la base de datos',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  eliminarElementoYActualizarLista = idElemento => {
    //Esta funcion esta encargada de eliminar el elemento de la lista, actualizar el estado y re-generar la lista.
    let lTotal = [...this.state.listaTotal];

    // eslint-disable-next-line no-unused-vars
    let removidos = _.remove(lTotal, elem => {
      return elem._id == idElemento;
    });
    this.setState(
      {
        ...this.state,
        listaTotal: lTotal,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorNombre = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getPersonas, persona => {
      return persona.nombre.toUpperCase().indexOf(filtro.toUpperCase()) > -1;
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorApellido = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getPersonas, persona => {
      return persona.apellido.toUpperCase().indexOf(filtro.toUpperCase()) > -1;
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  filtrarPorDocumento = async filtro => {
    //Esta funcion es la encargada de re-llamar al servidor para traer las notas filtradas.

    this.setState({
      ...this.state,
      loading: true,
    });

    let listaFiltrada = _.filter(this.props.data.getPersonas, persona => {
      return persona.num_doc.toUpperCase().indexOf(filtro.toUpperCase()) > -1;
    });

    this.setState(
      {
        ...this.state,
        loading: false,
        listaTotal: listaFiltrada,
      },
      function() {
        this.ordenarLista(1, 10);
      }
    );
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.data.getPersonas) {
      this.setState(
        {
          ...this.state,
          listaTotal: nextProps.data.getPersonas,
        },
        function() {
          this.ordenarLista(1, 10);
        }
      );
    }
  }

  ordenarLista = (numPagina, tamPagina) => {
    let listaOrdenada = _.orderBy(
      this.state.listaTotal,
      [
        persona => {
          return persona.apellido.toUpperCase();
        },
      ],
      ['asc']
    );

    let listaCorta = _.slice(
      listaOrdenada,
      0 + (numPagina - 1) * tamPagina,
      tamPagina * numPagina
    );

    this.setState({
      ...this.state,
      currentPage: numPagina,
      lista: listaCorta,
    });
  };

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    const pagination = {
      pageSize: 10,
      current: this.state.currentPage,
      total: this.state.listaTotal ? this.state.listaTotal.length : 0,
      onChange: (page, pageSize) => {
        this.ordenarLista(page, pageSize);
      },
    };

    return (
      <div>
        <TablaPersonas
          personas={this.state.lista}
          history={this.props.history}
          onDelete={this.onDelete}
          pagination={pagination}
          filtrarPorNombre={this.filtrarPorNombre}
          filtrarPorApellido={this.filtrarPorApellido}
          filtrarPorDocumento={this.filtrarPorDocumento}
        />
      </div>
    );
  }
}

export default withApollo(VerPersonas);
